import { ShowWarningBar } from "./warningBar";
import { AppState } from "./Pjax";
import { safeSessionStorage } from "./safeSessionStorage";
import { ProgCss } from "./ProgCss.Generated";

export function ReplaceFullPageWithError(nlTitle: string, enTitle: string, nlText: string, enText: string) {
    //probeer hier heel oude browsers nog te ondersteunen,
    //want deze code wordt ook uitgevoerd als de browser immers te oud is.

    const appState = AppState();
    const lang = appState?.getAttribute("lang");
    const title = lang === "NL" ? nlTitle : lang === "EN" ? enTitle : nlTitle + " / " + enTitle;

    const message = document.createElement("div");
    message.className = ProgCss.ErrorPage + ' ' + ProgCss.ErrorPage__centered;
    const header = document.createElement("h3");
    header.className = ProgCss.text_danger + ' ' + ProgCss.prg_box__header;
    header.textContent = title;
    message.appendChild(header);
    if (lang !== "EN") {
        const nlContent = document.createElement("div");
        nlContent.className = ProgCss.prg_box__content;
        nlContent.textContent = nlText;
        message.appendChild(nlContent);
    }
    if (lang !== "NL") {
        const enContent = document.createElement("div");
        enContent.className = ProgCss.prg_box__content;
        enContent.textContent = enText;
        message.appendChild(enContent);
    }
    document.body.textContent = '';
    document.body.appendChild(message);
    if (appState) {
        document.body.appendChild(appState);
    }
}

let sessionStorageWarningDisplayed = false;

export function UnsupportedBrowserModal(): Boolean {
    if (document.querySelector('[data-UnsupportedBrowserError]')) {
        return true;
    }

    const missingFeatures = [];
    if (!document.createElement('form').requestSubmit)
        missingFeatures.push('requestSubmit');

    if (!CSS.supports('color', 'color-mix(in oklch, white, black)'))
        missingFeatures.push('color-mix in oklch');

    if (missingFeatures.length) {
        ReplaceFullPageWithError(
            'Deze web browser wordt niet langer ondersteund',
            'This web browser is no longer supported',
            'Update deze browser of gebruik een andere. Ondersteund worden recente versies van bijv. '
            + 'Apple Safari, Google Chrome, Microsoft Edge, en Mozilla Firefox.',
            'Use a different browser or newer version of this one. Supported are (e.g.) recent versions of '
            + 'Apple Safari, Google Chrome, Microsoft Edge, and Mozilla Firefox.'
        );

        var code = document.createElement('code');
        code.textContent = 'ERR: ' + JSON.stringify(missingFeatures);
        (document.body.firstElementChild || document.body).appendChild(code);

        return true;
    }

    if (safeSessionStorage === null && !sessionStorageWarningDisplayed) {
        ShowWarningBar("Progress moet cookies en site-gegevens op het apparaat kunnen opslaan om goed te functioneren. Progress needs to store cookies and on-device site-data to function well.");
        sessionStorageWarningDisplayed = true;
    }

    const warningMessage = document.documentElement.getAttribute('data-UnsupportedBrowserWarning');
    if (!warningMessage)
        return false;

    console.log(warningMessage);
    try {
        if (safeSessionStorage?.getItem('hideUnsupportedBrowserModal') === 'true') {
            return false;
        }
    } catch (e) {
        // Safari throws QuotaExceededError in private mode
    }

    ShowWarningBar(warningMessage, () => {
        try {
            document.documentElement.removeAttribute('data-UnsupportedBrowserWarning');
            safeSessionStorage?.setItem('hideUnsupportedBrowserModal', 'true');
        } catch (e) {
            // Safari throws QuotaExceededError in private mode
        }
    });
    return false;
}
